// First-touch entry attribution. On the visitor's first arrival, persist where
// they came from (referrer, landing path, utm_*) in first-party cookies. The
// backend attribution middleware reads these on every request and stamps them
// onto the user at signup (users.acquisition_* columns, migration 056).
const LANDING_COOKIE = 'ls_entry_landing';
const REFERRER_COOKIE = 'ls_entry_referrer';
const UTM_COOKIES = {
    utm_source: 'ls_entry_utm_source',
    utm_medium: 'ls_entry_utm_medium',
    utm_campaign: 'ls_entry_utm_campaign',
};
const COOKIE_MAX_AGE_SECONDS = 90 * 24 * 3600;
const MAX_VALUE_LENGTH = 512;
const hasCookie = (name) => document.cookie.split('; ').some((c) => c.startsWith(`${name}=`));
const setCookie = (name, value) => {
    const trimmed = value.slice(0, MAX_VALUE_LENGTH);
    let cookie = `${name}=${encodeURIComponent(trimmed)}; Max-Age=${COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax`;
    if (REACT_APP_COOKIE_DOMAIN) {
        cookie += `; Domain=${REACT_APP_COOKIE_DOMAIN}`;
    }
    if (window.location.protocol === 'https:') {
        cookie += '; Secure';
    }
    document.cookie = cookie;
};
// The current visit's attribution, cached by captureEntryAttribution before
// utm_* params are stripped from the URL.
let capturedEntry = null;
export const getEntryAttribution = () => capturedEntry !== null && capturedEntry !== void 0 ? capturedEntry : readCurrentEntryAttribution();
const readCurrentEntryAttribution = () => {
    const params = new URLSearchParams(window.location.search);
    const referrer = document.referrer;
    const external = referrer && !referrer.includes(`//${window.location.hostname}`) ? referrer : '';
    return {
        referrer: external,
        landingPath: window.location.pathname + window.location.search,
        utmSource: params.get('utm_source') || '',
        utmMedium: params.get('utm_medium') || '',
        utmCampaign: params.get('utm_campaign') || '',
    };
};
// Captures first-touch entry attribution into cookies, then strips utm_*
// params from the URL. First touch wins: subsequent visits with the landing
// cookie already present only clean the URL.
export const captureEntryAttribution = () => {
    const current = readCurrentEntryAttribution();
    capturedEntry = current;
    if (!hasCookie(LANDING_COOKIE)) {
        setCookie(LANDING_COOKIE, current.landingPath);
        if (current.referrer) {
            setCookie(REFERRER_COOKIE, current.referrer);
        }
        if (current.utmSource) {
            setCookie(UTM_COOKIES.utm_source, current.utmSource);
        }
        if (current.utmMedium) {
            setCookie(UTM_COOKIES.utm_medium, current.utmMedium);
        }
        if (current.utmCampaign) {
            setCookie(UTM_COOKIES.utm_campaign, current.utmCampaign);
        }
    }
    const params = new URLSearchParams(window.location.search);
    const hadUtm = Object.keys(UTM_COOKIES).some((p) => params.has(p));
    if (hadUtm) {
        Object.keys(UTM_COOKIES).forEach((p) => params.delete(p));
        const query = params.toString();
        const cleaned = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
        window.history.replaceState(null, '', cleaned);
    }
};
